const initialState = {
    str: ''
}

const seaBookIssuedRed = (state = initialState, action) => {
    switch(action.type){
        case 'SEABOOK_ISSUED' : {
            return {
                ...state,
                str: action.str
            }
        }
        default: {
            return state
        }
    }
}

export default seaBookIssuedRed